import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import {
  PrimaryButton,
  ButtonSizes,
} from 'app/common/components/controls/button/button';

// eslint-disable-next-line @trello/less-matches-component
import styles from './AutomaticOnboardingOverlay.less';
import { OnboardingDialog } from '../../v2Overlays/OnboardingDialog';
import { AtlassianAccountOnboardingLinks } from '../../AtlassianAccountOnboardingLinks';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});
interface UpdateAccountProps {
  aaEmail: string;
  orgName?: string;
  onDismiss?: () => void;
  onClickUpdateAccount: () => void;
}
const getDomainFromEmail = (email: string) => {
  let emailDomain = email;
  const pos = email.search('@'); // get position of domain
  if (pos > 0) {
    emailDomain = email.slice(pos + 1); // use the slice method to get domain name, "+1" mean domain does not include "@"
  }
  return emailDomain;
};

export const UpdateAccount: FunctionComponent<UpdateAccountProps> = ({
  aaEmail,
  orgName,
  onDismiss,
  onClickUpdateAccount,
}) => (
  <OnboardingDialog
    title={format('update your trello account')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss && onDismiss}
    className={styles.updateAccountBody}
  >
    <div className={styles.updateAccountContent}>
      <p>
        {format('update account intro', {
          orgDomain: (
            <strong key={aaEmail}>{getDomainFromEmail(aaEmail)}</strong>
          ),
          orgName: <strong key={orgName}>{orgName}</strong>,
        })}
      </p>
      <p>{format('update account msg')}</p>
    </div>
    <div className={styles.updateAccountAction}>
      <PrimaryButton size={ButtonSizes.WIDE} onClick={onClickUpdateAccount}>
        {format('continue')}
      </PrimaryButton>
    </div>
  </OnboardingDialog>
);
